export const TAX_REPORT = "TAX_REPORT";
export const TAX_ERROR = "TAX_ERROR";
export const TAX_HIDE_ERROR = "TAX_HIDE_ERROR";
export const TAX_EMPTY_VALIDATION = "TAX_EMPTY_VALIDATION";
export const TAX_HIDE_EMPTY_VALIDATION = "TAX_HIDE_EMPTY_VALIDATION";
